/**
 * @flow
 * @relayHash c65ad9d6366934548fdce3d937df7e45
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ProxyLoginReverseMutationVariables = {||};
export type ProxyLoginReverseMutationResponse = {|
  +reverseProxyLogin: ?{|
    +ok: ?boolean,
    +reasons: ?any,
  |}
|};
export type ProxyLoginReverseMutation = {|
  variables: ProxyLoginReverseMutationVariables,
  response: ProxyLoginReverseMutationResponse,
|};
*/


/*
mutation ProxyLoginReverseMutation {
  reverseProxyLogin {
    ok
    reasons
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "reverseProxyLogin",
    "storageKey": null,
    "args": null,
    "concreteType": "ReverseProxyLogin",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "ok",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "reasons",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "ProxyLoginReverseMutation",
  "id": "a6c07f782cf92ee4c3d5220d0188a5bb",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ProxyLoginReverseMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": v0
  },
  "operation": {
    "kind": "Operation",
    "name": "ProxyLoginReverseMutation",
    "argumentDefinitions": [],
    "selections": v0
  }
};
})();
node.text = "mutation ProxyLoginReverseMutation {\n  reverseProxyLogin {\n    ok\n    reasons\n  }\n}\n";
(node/*: any*/).hash = '367c4ddf86ff777480ff16aeced6a745';
module.exports = node;
